<template>
  <v-card>
    <v-card-title>
      <span v-if="editItem === null">Create New Ad Hoc Request Item</span>
      <span v-else>Edit Ad Hoc Request Item</span>
    </v-card-title>

    <v-card-text>
      <v-form>
        <v-row>
          <v-col cols="4">
            <v-autocomplete v-model="panelTypeId" :items="panelTypes" item-value="id" item-text="code" label="Panel Type" :rules="[rules.required]">
              <template #label>Panel Type<red-asterisk/></template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete v-model="colorId" :items="colors" item-value="id" :item-text="item => `${item.code} ${item.name || ''}`" label="Color" :rules="[rules.required]">
              <template #label>Color<red-asterisk/></template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="tagNumber" label="Tag Number" :rules="[rules.required]">
              <template #label>Tag Number<red-asterisk/></template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3">
            <v-text-field v-model.number="length" label="Length (inch)">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field v-model.number="width" label="Width (inch)">
              <template #label>Width (inch)<red-asterisk/></template>
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field v-model.number="height" label="Height (inch)">
              <template #label>Height (inch)<red-asterisk/></template>
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field v-model.number="quantity" label="Quantity" :rules="[rules.required]">
              <template #label>Quantity<RedAsterisk/></template>
            </v-text-field>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="12">
            <v-file-input v-model="attachment" accept="image/*" label="Attachment">
              <template #label>Select New Attachment<RedAsterisk v-if="editItem === null"/></template>
            </v-file-input>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="12">
            <v-text-field v-model="notes" label="Notes" />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn color="normal" class="mr-2" @click="closeForm">CLOSE</v-btn>
      <v-btn color="primary" class="mr-2" @click="saveItem">{{ editItem === null ? 'CREATE' : 'UPDATE' }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  components: {
  },
  data: () => ({
    panelTypeId: null,
    length: 0,
    width: 0,
    height: 0,
    colorId: null,
    tagNumber: '',
    quantity: 0,
    notes: '',
    // attachment: null,

    panelTypes: [],
    colors: [],
    editItem: null,
    editItemIdx: null,

    rules: {
      required: v => !!v || 'This field is required',
    }
  }),
  created() {
    this.$api.wipPanelType.read({ filters: { is_listed: 1 } }).then(res => this.panelTypes = res.data);
    this.$api.color.read().then(res => this.colors = res);
  },
  computed: {
    ...mapState({
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
  },
  methods: {
    open(editItem = null, editItemIdx = null) {
      this.resetForm();
      this.editItem = editItem;
      this.editItemIdx = editItemIdx;
      if (editItem !== null) {
        this.panelTypeId = editItem.panel_type_id;
        this.colorId = editItem.color_id;
        this.length = editItem.length;
        this.height = editItem.height;
        this.width = editItem.width;
        this.quantity = editItem.quantity;
        this.notes = editItem.notes;
        this.tagNumber = editItem.tag_number;
        // this.attachment = null;
      }
    },
    resetForm() {
      this.panelTypeId = null;
      this.tagNumber = '';
      this.colorId = null;
      this.length = 0;
      this.width = 0;
      this.height = 0;
      this.quantity = 0;
      this.notes = '';
      this.editItem = null;
      this.editItemIdx = null;
      // this.attachment = null;
    },
    closeForm() {
      this.resetForm();
      this.$emit('close-form')
    },
    saveItem() {
      if (this.panelTypeId === null) return this.$bus.$emit('showError', 'Please select the Panel Type');
      if (this.colorId === null) return this.$bus.$emit('showError', 'Please select the Color');
      if (!this.tagNumber) return this.$bus.$emit('showError', 'Please enter the Tag Number');
      if (!this.quantity) return this.$bus.$emit('showError', 'Please enter Quantity');
      if (this.width === 0) return this.$bus.$emit('showError', 'Please enter the Width');
      if (this.height === 0) return this.$bus.$emit('showError', 'Please enter the Height');
      // if (this.editItem === null && !this.attachment) return this.$bus.$emit('showError', 'Please upload an Attachment');

      const item = {
        id: this.editItem?.id ?? null,
        panel_type_id: this.panelTypeId,
        tag_number: this.tagNumber,
        length: this.length,
        width: this.width,
        height: this.height,
        quantity: this.quantity,
        color_id: this.colorId,
        notes: this.notes,
        status_id: 1,
        is_deleted: 0,
        // attachment: this.editItem === null || this.attachment !== null ? this.attachment : null,
      };

      if (this.editItem === null) this.$emit('item-created', item);
      else this.$emit('item-updated', item, this.editItemIdx);
      this.closeForm();
    }
  },
};
</script>
